<template lang="pug">
  #ReservationIndex
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 預約查詢
    .container-width
      .p-3
        b-form-group.mb-2.text-gray(
          label="活動名稱"
        )
          b-form-select(
            id="campaign_code",
            required,
            v-model="searchInput.campaign_code",
            placeholder="請選擇活動名稱",
            style="border-radius: 20px;background-color: #eee;"
          )
            template(
              v-slot:first
            )
              b-form-select-option(
                :value="null",
                disabled
              ) 請選擇活動名稱
            b-form-select-option(
              v-for="(campaign_code,index) in reservationsTypeList",
              :key="campaign_code.id",
              :value="campaign_code.code"
            ) {{ campaign_code.name }}
        b-form-group.mb-3.text-gray(
          label="日期區間"
        )
          .d-flex.align-items-center
            b-input(
              v-model="searchInput.start_date"
              type="date",
              placeholder="開始區間",
              style="flex: 2!important;border-radius: 20px;background-color: #eee;width: calc(100%/3);"
            )
            p.mb-0.text-center(
              style="flex-grow: 0.5!important;"
            ) -
            b-input(
              v-model="searchInput.end_date"
              type="date",
              placeholder="結束區間",
              style="flex: 2!important;border-radius: 20px;background-color: #eee;width: calc(100%/3);"
            )
        .row.no-gutters
          .col-6.pr-2
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
              type="button",
              @click="resetHandler();",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
            ) 重置
          .col-6.pl-2
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
              type="button",
              @click="searchHandler()",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
            ) 搜尋
    .overflow-auto(
      :class="{ 'mr-3': reservations.length > 0, 'ml-3': reservations.length > 0 }"
    )
      table.table.table-bordered.table-striped
        thead.bg-black.text-white
          tr
            th.position-sticky(id='th1' scope='col', style="left: 0; top:0; background-color: #000; z-index: 2") 姓名
            th.position-sticky(id='th2' scope='col', style="top:0; background-color: #000; z-index: 2" :style="{ left: th1Width + 'px'}") 電話
            th.position-sticky(scope='col', style="left: 0; top:0; background-color: #000; z-index: 1") 報名日期
            th.position-sticky(scope='col', style="left: 0; top:0; background-color: #000; z-index: 1") 活動名稱
            th.position-sticky(scope='col', style="left: 0; top:0; background-color: #000; z-index: 1") 預約日期
            th.position-sticky(scope='col', style="left: 0; top:0; background-color: #000; z-index: 1") 預約時段
        tbody(
          v-if="reservations.length > 0"
        )
          tr(
            v-for="(reservation, index) in reservations",
            style="white-space: nowrap;"
          )
            th.position-sticky(id='th3' scope='row', style="left: 0; z-index: 1" :style="{'background-color': index%2 === 0 ? 'rgb(238,238,238)' : '#FFF' }") {{ reservation.Name }}
            th.position-sticky(id='th4' scope='row', style="left: 0; background-color: rgb(238,238,238); z-index: 1" :style="{ left: th3Width + 'px', 'background-color': index%2 === 0 ? 'rgb(238,238,238)' : '#FFF' }") {{ reservation.Mobile }}
            th(scope='row') {{ reservation.CreateTime.split(' ')[0] }}
            th(scope='row') {{ reservation.CampaignName }}
            th(scope='row') {{ reservation.RegisterDate }}
            th(scope='row') {{ reservation.RegisterSection }}
        tbody(
          v-else
        )
          tr
            td.text-center(
              colspan="9487"
            ) 暫無預約資料

    b-modal#reservation-cancel-modal(
      title="請填寫預約人資訊",
      centered,
      scrollable,
      hide-header,
      hide-footer,
      v-model="reservationCancelModalShow"
    )
      h5.text-center.mb-3 請填寫預約人資訊
      b-form-input.mb-3.border-black.border-width-lg(
        id="name",
        type="text",
        required,
        trim,
        v-model="reservationCancelForm.register_name",
        placeholder="姓名"
      )
      b-form-input.mb-3.border-black.border-width-lg(
        id="mobile",
        type="tel",
        required,
        trim,
        v-model="reservationCancelForm.register_phone",
        placeholder="手機"
      )
      .row.no-gutters
        .col-6.pr-2
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="reservationCancelModalShow = false",
            style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.15rem 0.15rem 0 #00000033;"
          ) 取消
        .col-6.pl-2
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="cancelReservationHandler()",
            style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.15rem 0.15rem 0 #00000033;"
          ) 確認

</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import { SA_RESERVATION_EDIT } from '@/router/sa/reservation';
import $ from 'jquery';

const moment = require('moment');

export default {
  name: 'ReservationIndex',
  components: {
    ProfilePhotoSticker
  },
  data() {
    return {
      searchInput: {
        campaign_code: null,
        start_date: null,
        end_date: null
      },
      nowSelect: 'checking',
      infiniteId: +new Date(),
      reservationCancelModalShow: false,
      reservationCancelForm: {
        member_uuid: null,
        campaign_code: null,
        register_date: null,
        register_section: null,
        register_name: null,
        register_phone: null
      },
      th1Width: 0,
      th3Width: 0
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('sa_reservation/resetHandler');
    vm.$store.commit('toggleLoading', false);
    vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 取得預約服務選項
      vm.$store.dispatch('sa_reservation/getReservationTypeListHandler')
        .then(() => {
          vm.$swal.close();
        });
  },
  methods: {
    // 搜尋
    searchHandler() {
      const vm = this;
      if (vm.searchInput.start_date && vm.searchInput.end_date) {
        const startDateFormat = moment(vm.searchInput.start_date);
        const endDateFormat = moment(vm.searchInput.end_date);
        if (endDateFormat.isBefore(startDateFormat)) {
          vm.$swal.fire({
            icon: 'error',
            title: '日期區間結束時間不可小於開始時間'
          });
          return;
        }else {
          vm.infiniteHandler();
        }
      } else if (!vm.searchInput.campaign_code && (!vm.searchInput.start_date || !vm.searchInput.end_date)) {

        vm.$swal.fire({
          icon: 'error',
          title: '請填寫活動名稱或是日期區間'
        });
        return;
      }else {
        vm.infiniteHandler();
      }
    },
    // 重置
    resetHandler() {
      const vm = this;
      vm.$store.commit('sa_reservation/resetHandler');
      vm.searchInput = {
        campaign_code: null,
        start_date: null,
        end_date: null
      };
    },
    infiniteHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 取得預約服務選項
      vm.$store.dispatch('sa_reservation/getReservationTypeListHandler')
        .then(() => {
          vm.$store.dispatch('sa_reservation/getReservationHandler', vm.searchInput)
            .then(() => {
              setTimeout(() => {
                if (vm.reservations.length > 0) {
                  vm.th1Width = document.getElementById('th1').clientWidth;
                  vm.th3Width = document.getElementById('th3').clientWidth;
                }
                vm.$swal.close();
              }, 500);
            });
        });
    },
    cancelReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '取消預約中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_reservation/deleteHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_reservation/resetHandler');
          vm.infiniteId += 1;
        });
    },
    editReservationHandler(reservation) {
      const vm = this;
      vm.$router.push({
        name: SA_RESERVATION_EDIT,
        params: {
          id: reservation.reservation_id,
          editInfo: reservation
        }
      });
    },
    confirmReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '預約確認中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_reservation/checkHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_reservation/resetHandler');
          vm.infiniteId += 1;
        });
    },
    doneReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '完成預約中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_reservation/successHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_reservation/resetHandler');
          vm.infiniteId += 1;
        });
    },
    // searchHandler() {
    //   const vm = this;
    //   if (!vm.searchInput.customer_name && !vm.searchInput.reservation_date) return;
    //   vm.$store.commit('sa_reservation/resetHandler');
    //   vm.infiniteId += 1;
    // },
    researtSearchHandler() {
      const vm = this;
      vm.searchInput.customer_name = null;
      vm.searchInput.reservation_date = null;
      vm.$store.commit('sa_reservation/resetHandler');
      vm.infiniteId += 1;
    },
    cancelReservationModalShowHandler(reservation) {
      const vm = this;
      if (vm.reservationCancelModalShow) return;
      vm.reservationCancelForm = {
        member_uuid: vm.memberInfo.member_line_uuid,
        campaign_code: reservation.CampaignCode,
        register_date: reservation.RegisterDate,
        register_section: reservation.RegisterSection,
        register_name: null,
        register_phone: null
      };
      vm.reservationCancelModalShow = true;
    },
    cancelReservationHandler() {
      const vm = this;
      if (!vm.reservationCancelModalShow || !vm.reservationCancelForm.member_uuid || !vm.reservationCancelForm.campaign_code || !vm.reservationCancelForm.register_date || !vm.reservationCancelForm.register_section) {
        return;
      } else if (!vm.reservationCancelForm.register_name) {
        vm.$swal.fire({
          icon: 'error',
          title: '預約人姓名尚未填寫'
        });
      } else if (!vm.reservationCancelForm.register_phone) {
        vm.$swal.fire({
          icon: 'error',
          title: '預約人手機尚未填寫'
        });
      } else {
        vm.$swal.fire({
          title: '取消預約中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
        vm.$store.dispatch('sa_my_customer/deleteHandler', vm.reservationCancelForm)
          .then(() => {
            vm.$swal.close();
            vm.reservationCancelModalShow = false;
            vm.$store.commit('sa_my_customer/resetHandler');
            vm.infiniteHandler();
          });
      }
    },
  },
  computed: {
    ...mapState({
      reservations: (state) => state.sa_reservation.reservations,
      reservationTimeList: (state) => state.sa_reservation.reservationTimeList,
      campaingCodeOptions: (state) => state.sa_reservation.campaingCodeOptions,
      reservationsTypeList: (state) => state.sa_reservation.reservationsTypeList,
    })
  }
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all .3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}
</style>
